/**
 * Маппинг английских названий цветов на hex-коды
 * Используется как fallback когда colour_hex не предоставлен бэкендом
 */
const COLOR_HEX_MAP = {
  beige: "#F5F5DC",
  black: "#000000",
  blue: "#0000FF",
  brown: "#A52A2A",
  gray: "#808080",
  grey: "#808080",
  green: "#008000",
  khaki: "#C3B091",
  lightblue: "#ADD8E6",
  "light blue": "#ADD8E6",
  multicolour: null, // Для мультиколора не показываем точку
  multicolor: null,
  orange: "#FFA500",
  pink: "#FFC0CB",
  purple: "#800080",
  red: "#FF0000",
  white: "#FFFFFF",
  yellow: "#FFFF00",
  navy: "#000080",
  cream: "#FFFDD0",
  gold: "#FFD700",
  silver: "#C0C0C0",
  turquoise: "#40E0D0",
  coral: "#FF7F50",
  burgundy: "#800020",
  olive: "#808000",
  mint: "#98FF98",
  lavender: "#E6E6FA",
  peach: "#FFCBA4",
  tan: "#D2B48C",
  teal: "#008080",
  maroon: "#800000",
  cyan: "#00FFFF",
  magenta: "#FF00FF",
  lime: "#00FF00",
  indigo: "#4B0082",
  violet: "#EE82EE",
  aqua: "#00FFFF",
  rose: "#FF007F",
  charcoal: "#36454F",
  ivory: "#FFFFF0",
  sand: "#C2B280",
  stone: "#928E85",
  slate: "#708090",
  pewter: "#8E9296",
  natural: "#F5F5DC",
}

/**
 * Маппинг английских названий цветов на русские
 * Используется для отображения цветов товаров в интерфейсе
 */
const COLOR_NAMES_RU = {
  beige: "Бежевый",
  black: "Чёрный",
  blue: "Синий",
  brown: "Коричневый",
  gray: "Серый",
  grey: "Серый",
  green: "Зелёный",
  khaki: "Хаки",
  lightblue: "Голубой",
  "light blue": "Голубой",
  multicolour: "Мультиколор",
  multicolor: "Мультиколор",
  orange: "Оранжевый",
  pink: "Розовый",
  purple: "Фиолетовый",
  red: "Красный",
  white: "Белый",
  yellow: "Жёлтый",
  navy: "Тёмно-синий",
  cream: "Кремовый",
  gold: "Золотой",
  silver: "Серебряный",
  turquoise: "Бирюзовый",
  coral: "Коралловый",
  burgundy: "Бордовый",
  olive: "Оливковый",
  mint: "Мятный",
  lavender: "Лавандовый",
  peach: "Персиковый",
  tan: "Песочный",
  teal: "Бирюзовый",
  maroon: "Бордовый",
  cyan: "Голубой",
  magenta: "Пурпурный",
  lime: "Лаймовый",
  indigo: "Индиго",
  violet: "Фиолетовый",
  aqua: "Аква",
  rose: "Розовый",
  charcoal: "Угольный",
  ivory: "Слоновая кость",
  sand: "Песочный",
  stone: "Каменный",
  slate: "Сланцевый",
  pewter: "Оловянный",
  natural: "Натуральный",
}

/**
 * Переводит название цвета с английского на русский
 * @param {string} color - Название цвета на английском
 * @returns {string} - Название цвета на русском или оригинал если перевод не найден
 */
export function translateColor(color) {
  if (!color) return "—"

  const lowerColor = color.toLowerCase().trim()
  const translated = COLOR_NAMES_RU[lowerColor]

  if (translated) {
    return translated
  }

  // Если перевод не найден, возвращаем оригинал с заглавной буквы
  return color.charAt(0).toUpperCase() + color.slice(1).toLowerCase()
}

/**
 * Возвращает hex-код цвета по названию
 * Используется как fallback когда colour_hex не предоставлен бэкендом
 * @param {string} color - Название цвета на английском
 * @returns {string|null} - Hex-код цвета или null
 */
export function getColorHex(color) {
  if (!color) return null

  const lowerColor = color.toLowerCase().trim()
  return COLOR_HEX_MAP[lowerColor] || null
}

export default translateColor
